import { Text } from '@mantine/core';
import { type ReactNode } from 'react';
import classNames from 'classnames';
import { GradientIcon } from '../GradientIcon/GradientIcon';
import { GRADIENT_ICON_VARIANT } from '@/types';
import styles from './MessageFeedbackWithAction.module.sass';

type MessageFeedbackWithActionProps = {
  icon: ReactNode;
  title: string;
  text?: string;
  actions: ReactNode[];
  iconVariant?: GRADIENT_ICON_VARIANT;
  compact?: boolean;
};

export const MessageFeedbackWithAction = ({
  icon,
  title,
  text,
  actions,
  iconVariant = GRADIENT_ICON_VARIANT.GRAY,
  compact = false,
}: MessageFeedbackWithActionProps) => {
  return (
    <div className={classNames(styles.feedbackContent, { [styles.compact]: compact })}>
      <GradientIcon icon={icon} variant={iconVariant} />
      <Text size="xl" fw={600} className={styles.title}>
        {title}
      </Text>
      {text && (
        <Text size="md" className={styles.text}>
          {text}
        </Text>
      )}
      {actions.length > 0 && <div className={styles.actionsWrapper}>{actions.map((action) => action)}</div>}
    </div>
  );
};
